import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Доступ только для пользователей с правом создания задач (преподаватели, staff или админы). */
export default function EditorRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const canEdit =
    user.is_teacher === true || user.is_staff === true || user.is_admin === true;
  if (!canEdit) {
    return <Navigate to="/" replace />;
  }

  return children;
}
